
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/specialist/subjects",
      function () {
        return require("private-next-pages/teachers/specialist/subjects/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/specialist/subjects"])
      });
    }
  